export const brandConfigObjectMap = new Map();

export const Brands = {
    VodacomBeatTheJams: 'vc-za-btj',
};

brandConfigObjectMap.set(Brands.VodacomBeatTheJams, {
    gameTitle: 'Beat the Jams',
    baseRoute: '/questions',
    webMarketingUrl: 'https://web.beatthejams.co.za/',
    gameUrl: 'https://beatthejams.co.za/',
    gtmIdentifier: 'GTM-5PVN76LG',
});

